import { Component, OnInit } from '@angular/core';
import { AppService } from './../../../../shared/services/geral/app.service';
import Swal from 'sweetalert2';
import { environment } from './../../../../../../../src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.css']
})
export class MenuLateralComponent implements OnInit {

  constructor(
    public svc: AppService,
    private translate: TranslateService,
    public sanitizer: DomSanitizer,
    private router: Router,
    private platformLocation: PlatformLocation
  ) {
    //Carrega as Traduções Gerais da Tela
    this.svc.sbGetTraducaoAuto("menu").subscribe((resp) => {
      this.traducao.menu = resp;
      this.carregarMenu();
    });

    this.svc.sbGetTraducaoAuto("geral").subscribe((resp) => {
      this.traducao.geral = resp;
    });
  }

  public icone: boolean = true;
  public menu_principal: any[] = [];
  public img_bandeira: string = "assets/img/Brasil.png";
  public traducao: any = {
    menu: "",
    geral: ""
  }
  public cd_login: string;
  public tema_css: boolean = true;
  public cssUrl: string = this.platformLocation.pathname + "assets/css/theme-black.css";
  public empresa: string = environment.empresa;
  public logoImg: any = this.sanitizer.bypassSecurityTrustResourceUrl(environment.logo);

  public loadCSS() {
    try {
      var that = this;

      $(".splashScreen").fadeIn(200, function () {
        setTimeout(function () {
          that.router.navigate([{
            outlets: {
              sidebar: ['menus'],
              primary: ['blank']
            }
          }], { skipLocationChange: true });
        }, 50);

        var cssLink = $("<link id='tema'>");
        $("head #tema").remove();
        $("head").append(cssLink);

        cssLink.attr({
          rel: "stylesheet",
          type: "text/css",
          href: that.cssUrl
        });

        setTimeout(function () {
          $("body .splashScreen").fadeOut(700);
          Swal.fire({
            title: "",
            text: that.traducao.geral.pronto,
            icon: "success",
            timer: 1000,
            showCancelButton: false,
            showConfirmButton: false
          });
        }, 50);
      });

    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!")
    }
  };

  public escolherTema() {
    environment.tema_css = this.tema_css ? "black" : "white";
    this.cssUrl = this.platformLocation.pathname + (this.tema_css ? "assets/css/theme-black.css" : "assets/css/theme-white.css");
    this.loadCSS();
  }

  public sbMudarIdioma(sigla: string) {

    try {
      switch (sigla) {
        case "pt":
          this.img_bandeira = "assets/img/Brasil.png";
          break;
        case "en":
          this.img_bandeira = "assets/img/Ingles3.png";
          break;
        case "es":
          this.img_bandeira = "assets/img/Espanhol.png";
          break;
      }

      this.svc.sbSelecionarIdioma(sigla);

      var that = this;
      setTimeout(function () {
        Swal.fire({
          title: "",
          text: that.traducao.geral.pronto,
          icon: "success",
          timer: 1000,
          showCancelButton: false,
          showConfirmButton: false
        });
      }, 200);
    } catch (e) {
      this.svc.sbExibirAlerta("error", "Oops...", "Algo deu errado, por favor entre em contato com o Suporte!")
    }
  }

  public carregarMenu() {
    this.menu_principal = [
      // { src: "controle-docs", titulo: this.traducao.menu.controle_documentos, icon: "fa fa-desktop mr-md", fl_ativado: false, tipo: "menu" },
      { src: "cadastro-poderes", titulo: this.traducao.menu.cadastro_poderes, icon: "fa fa-pencil mr-md", fl_ativado: false, tipo: "menu" },
      { src: "cliente-sem", titulo: "Clientes sem Autorizador", icon: "fa fa-user mr-md", fl_ativado: false, tipo: "menu" },
      { src: "upload-contratos", titulo: this.traducao.menu.upload_contratos, icon: "fa fa-upload mr-md", fl_ativado: false, tipo: "menu" },
      { src: "assinatura-interna", titulo: this.traducao.menu.assinatura_contratos, icon: "gi gi-bullets mr-md", fl_ativado: false, tipo: "menu" },
      { src: "feito-conferido", titulo: this.traducao.menu.feito_conferido, icon: "fa fa-eye mr-md", fl_ativado: false, tipo: "menu" }
      /*{
        src: "", titulo: this.traducao.menu.relatorios, icon: "fa fa-file-text sidebar-nav-icon mr-md", fl_ativado: false, tipo: "subMenu", ativo: false, items: [
          { src: "", titulo: this.traducao.menu.contratos, icon: "fa fa-file-text-o ml-xs mr-md", fl_ativado: false, tipo: "menu" },
          { src: "", titulo: this.traducao.menu.email_enviados, icon: "fa fa-file-text-o ml-xs mr-md", fl_ativado: false, tipo: "menu" },
          { src: "", titulo: this.traducao.menu.upload_contratos, icon: "fa fa-file-text-o ml-xs mr-md", fl_ativado: false, tipo: "menu" }
        ]
      }*/
    ];
  }

  ngOnInit() {
    this.carregarMenu();
    this.cd_login = environment.cd_login
  }

}
